export default function getPercent(value: number, total: number): number {
  return Math.min(
    100,
    Math.max(0, Math.round((value / Math.max(1, total || 1)) * 100))
  )
}
